var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-switch',{model:{value:(_vm.seeTemporals),callback:function ($$v) {_vm.seeTemporals=$$v},expression:"seeTemporals"}},[_vm._v("Temporales")]),_c('Teeth',{ref:"teeth",attrs:{"seeTemporals":_vm.seeTemporals}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }